var map = {
	"./LA.jpg": 63368,
	"./LH.jpg": 19650,
	"./LL.jpg": 79029,
	"./NONE.jpg": 61905,
	"./RA.jpg": 13731,
	"./RH.jpg": 54176,
	"./RL.jpg": 71646,
	"./ST.jpg": 32868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71797;